/**
 *  Kill-switch for slot-isolated cabinet filter option state.
 *
 *  When enabled (the default), cabinet filter option reads, writes, and loading gates are keyed
 *  by the request's cabinet identifier + filter index instead of the shared mutable
 *  currentCabinet/currentFilter, so a late response for one filter can never land in or be
 *  rendered as another filter's options.
 *
 *  Dev/test kill-switch only — not wired to UI or remote config. Disabling restores the legacy
 *  currentCabinet/currentFilter routing so the cross-slot race can be demonstrated in tests.
 */
let slotIsolationEnabled = true;
const isCabinetFilterOptionsSlotIsolationEnabled = () => slotIsolationEnabled;
const setCabinetFilterOptionsSlotIsolationEnabled = enabled => {
  slotIsolationEnabled = enabled === true;
};
export { isCabinetFilterOptionsSlotIsolationEnabled, setCabinetFilterOptionsSlotIsolationEnabled };